package com.parmartechnologies.core.feature.profile.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.ExperimentalTime

@Serializable
data class Profile @OptIn(ExperimentalTime::class) constructor(
    @SerialName("user_id") var UserID: String = "",
    @SerialName("name") var Name: String = "",
    @SerialName("designation") var Designation: String = "",
    @SerialName("yearOfExperience") var YearOfExperience: String = "",
    @SerialName("knownLanguages") var KnownLanguages: String = "",
): BaseDataClass()